export default [
  '$rootScope',
  'contentTemplatesService',
  '$timeout',
  FeatureFocus,
]

export function FeatureFocus($rootScope, contentTemplatesService, $timeout) {
  this.customButtons = []

  this.sendEvent = (evt, name) => {
    $rootScope.$broadcast('DISPATCH', {
      type: 'HANDLE_COMMANDS',
      sub_type: name,
      feature: this.feature,
    })
    evt.preventDefault()
    evt.stopPropagation()
  }

  this.commentClick = (index, e) => {
    $rootScope.$broadcast('CONTENT_COMMENT', {
      type: 'OPEN_COMMENT',
      index,
    })
  }

  this.requestChannelsModal = (feature) => {
    $rootScope.$broadcast('el.requestChannelsModal', feature)
  }

  this.$onInit = () => {
    const contentTemplate = contentTemplatesService.get(this.feature.type)
    this.customButtons = contentTemplate.customHandleButtons || []
  }
}
